import React from "react";
import { useSelector } from "react-redux";
import { Cell, Legend, Pie, PieChart, Tooltip } from "recharts";
import classes from "./SubscribersChart.module.css";

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
   cx,
   cy,
   midAngle,
   innerRadius,
   outerRadius,
   percent,
}) => {
   const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
   const x = cx + radius * Math.cos(-midAngle * RADIAN);
   const y = cy + radius * Math.sin(-midAngle * RADIAN);

   return (
      <text
         x={x}
         y={y}
         fill="white"
         textAnchor={x > cx ? "start" : "end"}
         dominantBaseline="central"
      >
         {`${(percent * 100).toFixed(0)}%`}
      </text>
   );
};

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

const SubscribersPieChart = () => {
   const {
      dashboard: { dashboardResponse },
   } = useSelector((state) => state);

   const sortedGraphData = () => {
      const subscribers = {
         name: "Active Subscribers",
         value: dashboardResponse?.totalNumberOfSubscribed ?? 0,
      };

      const members = {
         name: "Total Members",
         value: dashboardResponse?.totalNumberOfMembers ?? 0,
      };

      const activeUsers = {
         name: "Active Users",
         value: dashboardResponse?.totalNumberOfActiveUsers ?? 0,
      };

      const numberOfUsers = {
         name: "Total Users",
         value: dashboardResponse?.totalNumberOfUsers ?? 0,
      };

      return [subscribers, members, activeUsers, numberOfUsers];
   };

   return (
      <div className={classes.container}>
         <PieChart width={400} height={400}>
            <Pie
               data={sortedGraphData()}
               innerRadius={0}
               outerRadius={120}
               dataKey="value"
               nameKey="name"
               labelLine={false}
               label={renderCustomizedLabel}
            >
               {sortedGraphData().map((entry, index) => {
                  return <Cell key={`cell-${index}`} fill={COLORS[index]} />;
               })}
            </Pie>
            <Legend verticalAlign="bottom" align="left" height={30} />
            <Tooltip />
         </PieChart>
      </div>
   );
};

export default SubscribersPieChart;
